export default "__VITE_ASSET__NQr90u5J__"